import React from 'react';
import { HoverCard, Text, Flex, Stack, Badge, Divider } from '@mantine/core';
import { useQuery } from '@apollo/client';
import dayjs from 'dayjs';

import { GET_STAND_IN_STATUS } from '../../apollo/queries/standInManagement';
import { StandIn } from '../../codegen/graphql';

function StandInStatus() {
    const { data, loading } = useQuery(GET_STAND_IN_STATUS);

    const isStandingIn = data?.getCurrentUserStandInStatus?.isStandingIn;
    const standInsFor: StandIn[] =
        data?.getCurrentUserStandInStatus?.standInsFor;
    const myStandIn: StandIn = data?.getCurrentUserStandInStatus?.myStandIn;

    if (loading || !data || (!isStandingIn && !myStandIn)) {
        return null;
    }

    const renderStandIn = (
        standIn: StandIn,
        isPrimaryUser: boolean,
        index: number,
    ) => {
        return (
            <>
                <Stack gap="12px">
                    <Flex justify="space-between">
                        <Stack gap="0">
                            <Text size="sm" className="text-gray-300" fw="500">
                                {isPrimaryUser
                                    ? 'My Stand-In:'
                                    : 'Standing in for:'}
                            </Text>
                            <Text size="lg" fw="700">
                                {isPrimaryUser
                                    ? `${standIn.substituteUser.firstName} ${standIn.substituteUser.lastName}`
                                    : `${standIn.primaryUser.firstName} ${standIn.primaryUser.lastName}`}
                            </Text>
                        </Stack>
                        <Badge color="red" variant="light">
                            Stand-In
                        </Badge>
                    </Flex>
                    <Flex>
                        <Text size="sm" className="text-gray-300">
                            Duration:
                        </Text>
                        <Text size="sm" className="ml-1">
                            {dayjs(standIn.start).format('DD/MM/YYYY')} -{' '}
                            {dayjs(standIn.end).format('DD/MM/YYYY')} (
                            {dayjs(standIn.end).diff(standIn.start, 'day')}{' '}
                            days)
                        </Text>
                    </Flex>
                </Stack>
                {index !== standInsFor.length - 1 &&
                    standInsFor.length !== 0 && (
                        <Divider size="xs" color="#EAEAEA" />
                    )}
            </>
        );
    };

    return (
        <div className="mr-[40px]">
            <HoverCard
                width={320}
                shadow="md"
                position="bottom-start"
                radius="lg"
            >
                <HoverCard.Target>
                    <Flex
                        align="center"
                        gap={8}
                        className="bg-white bg-opacity-20 border border-solid rounded-full border-white px-3 h-[30px] cursor-default"
                    >
                        <div
                            className={`w-[10px] h-[10px] rounded-full ${
                                isStandingIn ? 'bg-red-600' : 'bg-green-400'
                            }`}
                        />
                        <Text color="white">
                            {isStandingIn ? 'On Stand-In' : 'My Stand-In'}
                        </Text>
                    </Flex>
                </HoverCard.Target>
                <HoverCard.Dropdown>
                    <Stack>
                        {isStandingIn
                            ? standInsFor.map((standIn, index) =>
                                  renderStandIn(standIn, false, index),
                              )
                            : renderStandIn(myStandIn, true, 0)}
                    </Stack>
                </HoverCard.Dropdown>
            </HoverCard>
        </div>
    );
}

export default StandInStatus;
